var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApartmentSegment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 30.625H20.4167M27.7083 30.625V7.29167C27.7083 6.51812 27.401 5.77625 26.8541 5.22927C26.3071 4.68229 25.5652 4.375 24.7917 4.375H10.2083C9.43479 4.375 8.69292 4.68229 8.14594 5.22927C7.59896 5.77625 7.29167 6.51812 7.29167 7.29167V30.625H27.7083ZM27.7083 30.625H30.625H27.7083ZM27.7083 30.625H20.4167H27.7083ZM7.29167 30.625H4.375H7.29167ZM7.29167 30.625H14.5833H7.29167ZM13.125 10.2083H14.5833H13.125ZM13.125 16.0417H14.5833H13.125ZM20.4167 10.2083H21.875H20.4167ZM20.4167 16.0417H21.875H20.4167ZM14.5833 30.625V23.3333C14.5833 22.9466 14.737 22.5756 15.0105 22.3021C15.284 22.0286 15.6549 21.875 16.0417 21.875H18.9583C19.3451 21.875 19.716 22.0286 19.9895 22.3021C20.263 22.5756 20.4167 22.9466 20.4167 23.3333V30.625H14.5833Z",
    stroke: "#D2232A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentSegment);
export default __webpack_public_path__ + "static/media/apartment-segment.04a8ca22d6a3f93e2440776aff8272c8.svg";
export { ForwardRef as ReactComponent };